import React from 'react';
import { Link } from 'react-router-dom';
import { SquareIcon } from 'lucide-react';
import { useTimer } from '../../../contexts/TimerContext';
import { useNow } from '../../../hooks/useNow';
import { formatElapsed } from '../../../utils/timer';

/** Det første og største på I dag, så længe en timer kører. */
export function ActiveTimerCard() {
  const {
    timer,
    requestStop
  } = useTimer();
  const now = useNow(Boolean(timer));
  if (!timer) return null;
  return <section aria-label="Aktiv timer" className="rounded-card border border-accent/60 bg-white p-5 md:p-6" data-id="element-674" data-mp="23vqzar60htmf">
      <p className="text-sm font-medium text-accent" data-id="element-675" data-mp="1tv86v80dt4sw">Aktiv timer</p>
      <Link to={`/admin/sager/${timer.caseId}`} className="mt-1 block truncate font-display text-xl font-bold text-ink hover:underline" data-id="element-676" data-mp="1twrrfat2m20h">
        {timer.caseTitle || 'Sag'}
      </Link>
      <p className="mt-2 font-display text-[clamp(2.75rem,12vw,3.75rem)] font-bold leading-none tracking-tight text-ink tabular-nums" data-id="element-677" data-mp="3oaj4kkalz40o">
        {formatElapsed(now - new Date(timer.startedAt).getTime())}
      </p>
      <button type="button" onClick={requestStop} className="mt-5 inline-flex h-14 w-full items-center justify-center gap-2 rounded-full bg-accent text-base font-semibold text-white transition-colors duration-150 hover:bg-accent-deep sm:w-auto sm:px-10" data-id="element-678" data-mp="bd1ftl4r791l">
        <SquareIcon className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-679" data-mp="g6nl2s8l8and" />
        Stop timer
      </button>
    </section>;
}